// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 3524 ? "app" : chunkId) + "." + {"3524":"d171f3f0","4714":"2cbd44eb","6282":"0a97db44"}[chunkId] + ".chunk.css";
};